<template>
    <input v-bind="$attrs" :type="type" :name="name" :value="value" @input="$emit('input', $event.target.value)" class="form-input" :class="[{ 'form-danger': error }, width, classes]" />
</template>

<script>
export default {
  inject: ['$validator'],

  inheritAttrs: false,
  props: {
    value: {
      required: false,
      Type: String,
      default: '',
    },
    name: {
      required: true,
      Type: String,
    },
    type: {
      required: false,
      type: String,
      default: 'text',
    },
    error: {
      type: String,
      default: null,
    },
    width: {
      required: false,
      type: String,
      default: 'w-full',
    },
    classes: {
      required: false,
      type: String,
      default: ''
    }
  },
  /*
  mounted() {
    if (this.val) {
      this.$emit('input', this.val)
    }
  },
  */
}
</script>
